document.addEventListener('DOMContentLoaded', () => {
  const initCarousel = (carousel) => {
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';

    const track = carousel.querySelector('[data-track]');
    if (!track) return;

    // Cloned list scrolls into view, so it must stay clickable: keep it out of the tab order only
    carousel.querySelectorAll('.product-showcase-list[aria-hidden="true"] :is(a, button, input, select, textarea, [tabindex])').forEach((el) => {
      el.setAttribute('tabindex', '-1');
    });

    const isManual = carousel.classList.contains('stop-scroll');

    let isDragging = false;
    let hasDragged = false;
    let startX = 0;
    const DRAG_THRESHOLD = 5;

    // Prevent native image ghost drag
    carousel.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

    // Block click navigation after drag
    carousel.addEventListener('click', (e) => {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);

    // --- DRAG HANDLING ---
    if (isManual) {
      // Manual mode: drag via native scrollLeft
      let startScrollLeft = 0;

      carousel.addEventListener('mousedown', (e) => {
        if (e.target.closest('button')) return;
        isDragging = true;
        hasDragged = false;
        carousel.style.cursor = 'grabbing';
        startX = e.pageX;
        startScrollLeft = carousel.scrollLeft;
        e.preventDefault();
      });

      carousel.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const walk = e.pageX - startX;
        if (!hasDragged && Math.abs(walk) > DRAG_THRESHOLD) {
          hasDragged = true;
        }
        carousel.scrollLeft = startScrollLeft - walk;
      });

      const handleMouseUp = () => {
        if (!isDragging) return;
        isDragging = false;
        carousel.style.cursor = 'grab';
      };

      carousel.addEventListener('mouseup', handleMouseUp);
      carousel.addEventListener('mouseleave', handleMouseUp);

      // Touch events for manual mode
      let touchStartY = 0;
      let isHorizontalSwipe = false;

      carousel.addEventListener('touchstart', (e) => {
        if (e.target.closest('button')) return;
        isDragging = true;
        hasDragged = false;
        startX = e.touches[0].pageX;
        touchStartY = e.touches[0].pageY;
        isHorizontalSwipe = false;
        startScrollLeft = carousel.scrollLeft;
      }, { passive: true });

      carousel.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const x = e.touches[0].pageX;
        const y = e.touches[0].pageY;
        const deltaX = Math.abs(x - startX);
        const deltaY = Math.abs(y - touchStartY);

        if (!isHorizontalSwipe && (deltaX > 5 || deltaY > 5)) {
          isHorizontalSwipe = deltaX > deltaY;
        }
        if (!isHorizontalSwipe) return;

        if (!hasDragged && deltaX > DRAG_THRESHOLD) {
          hasDragged = true;
        }
        e.preventDefault();
        carousel.scrollLeft = startScrollLeft - (x - startX);
      }, { passive: false });

      carousel.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        carousel.style.cursor = 'grab';
        isHorizontalSwipe = false;
      });

    } else {
      // Autoplay mode: drag via transform
      let currentTranslate = 0;
      const scrollDuration = parseFloat(carousel.dataset.scrollDuration) || 20;

      const getCurrentTranslate = () => {
        const style = window.getComputedStyle(track);
        const match = style.transform.match(/matrix.*\((.+)\)/);
        if (!match) return 0;
        return parseFloat(match[1].split(', ')[4]) || 0;
      };

      carousel.addEventListener('mousedown', (e) => {
        if (e.target.closest('button')) return;
        isDragging = true;
        hasDragged = false;
        carousel.style.cursor = 'grabbing';
        startX = e.pageX;
        currentTranslate = getCurrentTranslate();
        track.style.animation = 'none';
        track.style.transform = `translateX(${currentTranslate}px)`;
        e.preventDefault();
      });

      carousel.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const walk = e.pageX - startX;
        if (!hasDragged && Math.abs(walk) > DRAG_THRESHOLD) {
          hasDragged = true;
        }
        track.style.transform = `translateX(${currentTranslate + walk}px)`;
      });

      const handleMouseUp = () => {
        if (!isDragging) return;
        isDragging = false;
        carousel.style.cursor = 'grab';

        const finalTranslate = getCurrentTranslate();
        const trackWidth = track.scrollWidth / 2;
        let normalizedTranslate = finalTranslate % trackWidth;
        if (normalizedTranslate > 0) normalizedTranslate -= trackWidth;

        const duration = scrollDuration;
        const progress = Math.abs(normalizedTranslate) / trackWidth;
        const delay = -(progress * duration);

        track.style.transform = '';
        track.style.animationDelay = `${delay}s`;
        track.style.animationName = 'scroll-horizontal';
        track.style.animationDuration = `${duration}s`;
        track.style.animationTimingFunction = 'linear';
        track.style.animationIterationCount = 'infinite';
      };

      carousel.addEventListener('mouseup', handleMouseUp);
      carousel.addEventListener('mouseleave', handleMouseUp);

      // Touch events for autoplay mode
      let touchStartY = 0;
      let isHorizontalSwipe = false;

      carousel.addEventListener('touchstart', (e) => {
        if (e.target.closest('button')) return;
        isDragging = true;
        hasDragged = false;
        startX = e.touches[0].pageX;
        touchStartY = e.touches[0].pageY;
        isHorizontalSwipe = false;
        currentTranslate = getCurrentTranslate();
        track.style.animation = 'none';
        track.style.transform = `translateX(${currentTranslate}px)`;
      }, { passive: true });

      carousel.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const x = e.touches[0].pageX;
        const y = e.touches[0].pageY;
        const deltaX = Math.abs(x - startX);
        const deltaY = Math.abs(y - touchStartY);

        if (!isHorizontalSwipe && (deltaX > 5 || deltaY > 5)) {
          isHorizontalSwipe = deltaX > deltaY;
        }
        if (!isHorizontalSwipe) return;

        if (!hasDragged && deltaX > DRAG_THRESHOLD) {
          hasDragged = true;
        }
        e.preventDefault();
        track.style.transform = `translateX(${currentTranslate + (x - startX)}px)`;
      }, { passive: false });

      carousel.addEventListener('touchend', () => {
        if (!isDragging) return;
        handleMouseUp();
        isHorizontalSwipe = false;
      });

      // Autoplay-only: hover pause, modal pause
      let modalOpen = false;

      carousel.addEventListener('mouseenter', () => {
        if (!isDragging) {
          track.style.animationPlayState = 'paused';
        }
      });

      carousel.addEventListener('mouseleave', () => {
        if (!isDragging && !modalOpen) {
          track.style.animationPlayState = 'running';
        }
      });

      document.addEventListener('quickadd:open', () => {
        modalOpen = true;
        track.style.animationPlayState = 'paused';
      });

      document.addEventListener('quickadd:close', () => {
        modalOpen = false;
        if (!isDragging) {
          track.style.animationPlayState = 'running';
        }
      });
    }

    // --- MANUAL-ONLY: arrows, progress bar, toggle-details ---
    if (isManual) {
      const block = carousel.closest('.collection-products-block');
      if (!block) return;

      const prevBtn = block.querySelector('[data-arrow-prev]');
      const nextBtn = block.querySelector('[data-arrow-next]');
      const progressBar = block.querySelector('[data-progress-bar]');
      const infiniteLoop = carousel.hasAttribute('data-infinite-loop');

      const getStep = () => {
        const firstCard = carousel.querySelector('.product-card-showcase');
        if (!firstCard) return 300;
        const gap = parseFloat(getComputedStyle(carousel.querySelector('.product-showcase-list')).gap) || 0;
        return firstCard.offsetWidth + gap;
      };

      const getOriginalWidth = () => {
        const list = carousel.querySelector('.product-showcase-list');
        return list ? list.scrollWidth : carousel.scrollWidth;
      };

      const updateControls = () => {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;
        const scrollLeft = carousel.scrollLeft;

        if (progressBar) {
          let progress;
          if (infiniteLoop && maxScroll > 0) {
            const originalWidth = getOriginalWidth();
            progress = Math.min(scrollLeft / originalWidth, 1);
          } else {
            progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;
          }
          progressBar.style.width = (progress * 100) + '%';
        }

        if (!infiniteLoop && prevBtn && nextBtn) {
          prevBtn.disabled = scrollLeft <= 1;
          nextBtn.disabled = scrollLeft >= maxScroll - 1;
        }
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          const step = getStep();
          if (infiniteLoop && carousel.scrollLeft <= 1) {
            const originalWidth = getOriginalWidth();
            carousel.scrollLeft = originalWidth;
            requestAnimationFrame(() => {
              carousel.scrollBy({ left: -step, behavior: 'smooth' });
            });
          } else {
            carousel.scrollBy({ left: -step, behavior: 'smooth' });
          }
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const step = getStep();
          const maxScroll = carousel.scrollWidth - carousel.clientWidth;
          if (infiniteLoop && carousel.scrollLeft >= maxScroll - 1) {
            const originalWidth = getOriginalWidth();
            carousel.scrollLeft = carousel.scrollLeft - originalWidth;
            requestAnimationFrame(() => {
              carousel.scrollBy({ left: step, behavior: 'smooth' });
            });
          } else {
            carousel.scrollBy({ left: step, behavior: 'smooth' });
          }
        });
      }

      carousel.addEventListener('scroll', updateControls, { passive: true });
      updateControls();
    }

    // Toggle-details handler (delegated) — works in both autoplay and manual modes
    carousel.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action="toggle-details"]');
      if (!btn) return;
      e.stopPropagation(); // Prevent other global handlers from double-toggling
      const card = btn.closest('.product-card-showcase');
      if (!card) return;
      const isActive = card.classList.toggle('details-active');
      btn.setAttribute('aria-expanded', String(isActive));
    });

    // Set initial cursor
    carousel.style.cursor = 'grab';
  };

  const carousels = document.querySelectorAll('[data-carousel]');
  carousels.forEach(initCarousel);
});
